(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["namiki-v2-h03"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('namiki-shop-tabs')) {
    customElements.define('namiki-shop-tabs', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.tabs = [...this.querySelectorAll('[role="tab"]')];
        this.panels = [...this.querySelectorAll('[role="tabpanel"]')];
        this.onClick = event => {
          const tab = event.target.closest('[role="tab"]');
          if (tab && this.contains(tab)) this.select(tab);
        };
        this.onKey = event => {
          const tab = event.target.closest('[role="tab"]');
          if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          event.stopPropagation();
          const index = this.tabs.indexOf(tab);
          const next = event.key === 'Home' ? 0 : event.key === 'End' ? this.tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length;
          this.select(this.tabs[next]);
          this.tabs[next].focus();
        };
        this.onVariantChange = event => {
          const select = event.target.closest('[data-n2-variant]');
          if (!select) return;
          const option = select.selectedOptions[0];
          const card = select.closest('.n2-shop-card');
          card.querySelector('[data-n2-price]').textContent = option.dataset.price;
          card.querySelectorAll('[data-n2-details], .n2-shop-image, h3 a').forEach(link => { link.href = option.dataset.url; });
          const button = card.querySelector('[data-n2-add]');
          button.disabled = option.dataset.available !== 'true';
          button.querySelector('span').textContent = button.disabled ? button.dataset.soldLabel : button.dataset.addLabel;
        };
        this.onCartMessage = event => {
          const error = event.target.querySelector('[data-n2-error]');
          if (!error) return;
          error.hidden = event.detail.status !== 'error';
          error.textContent = event.detail.error || '';
        };
        this.addEventListener('change', this.onVariantChange);
        this.addEventListener('cart-notification:show', this.onCartMessage);
        this.addEventListener('click', this.onClick);
        this.addEventListener('keydown', this.onKey);
        this.blockSelected = event => {
          const card = event.target.closest('[data-product-block]');
          if (!card || !this.contains(card)) return;
          const panel = card.closest('[role="tabpanel"]');
          const tab = this.tabs.find(item => item.getAttribute('aria-controls') === panel.id);
          if (tab) this.select(tab);
        };
        document.addEventListener('shopify:block:select', this.blockSelected);
      }
      disconnectedCallback() { this.removeEventListener('change', this.onVariantChange); this.removeEventListener('cart-notification:show', this.onCartMessage); this.removeEventListener('click', this.onClick); this.removeEventListener('keydown', this.onKey); document.removeEventListener('shopify:block:select', this.blockSelected); this.ready = false; }
      select(tab) {
        this.tabs.forEach(item => { const active = item === tab; item.setAttribute('aria-selected', String(active)); item.tabIndex = active ? 0 : -1; });
        this.panels.forEach(panel => { panel.hidden = panel.id !== tab.getAttribute('aria-controls'); });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
